const TosContent = () => {
  return (
    <div className="space-y-4 text-sm text-adv-lightGray">
      <p className="text-xs text-adv-mediumGray">Last updated: February 12, 2026</p>

      <section>
        <h3 className="text-white font-bold mb-1">1. Acceptance of Terms</h3>
        <p>
          By creating an account or using Exodus ADV ("the Platform"), you agree to be bound by these
          Terms of Service. If you do not agree, do not use the Platform.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">2. Description of Service</h3>
        <p>
          Exodus ADV is a platform that connects adventure motorcycle riders for group rides and events.
          We provide tools for ride organizers to create and manage rides, and for riders to discover
          and RSVP to rides in their area.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">3. User Accounts</h3>
        <p>
          You must provide accurate information when creating an account. You are responsible for
          maintaining the security of your account credentials. You must be at least 18 years old
          to use the Platform.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">4. Assumption of Risk</h3>
        <p>
          <span className="font-bold text-white">Motorcycle riding is inherently dangerous.</span> By
          using the Platform to join rides, you acknowledge and accept the risks associated with
          motorcycle riding, including but not limited to injury, property damage, and death. You
          participate in all rides at your own risk.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">5. Limitation of Liability</h3>
        <p>
          Exodus ADV is a platform for connecting riders and is not responsible for the conduct,
          safety, or actions of any ride organizer or participant. We do not guarantee the safety,
          route quality, or suitability of any ride listed on the Platform. To the fullest extent
          permitted by law, Exodus ADV shall not be liable for any direct, indirect, incidental,
          or consequential damages arising from your use of the Platform or participation in any ride.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">6. User Conduct</h3>
        <p>You agree not to:</p>
        <ul className="list-disc list-inside mt-1 space-y-1">
          <li>Use the Platform for any unlawful purpose</li>
          <li>Harass, threaten, or intimidate other users</li>
          <li>Post false or misleading ride information</li>
          <li>Impersonate any person or entity</li>
          <li>Interfere with the proper functioning of the Platform</li>
        </ul>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">7. Content and Intellectual Property</h3>
        <p>
          You retain ownership of content you submit to the Platform. By posting content, you grant
          Exodus ADV a non-exclusive, royalty-free license to use, display, and distribute your
          content in connection with the Platform.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">8. Privacy</h3>
        <p>
          Your use of the Platform is also governed by our Privacy Policy. Your location data is
          used to show you nearby rides and is shared with ride organizers when you RSVP.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">9. Termination</h3>
        <p>
          We reserve the right to suspend or terminate your account at any time for violation of
          these Terms or for any other reason at our sole discretion.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">10. Changes to Terms</h3>
        <p>
          We may update these Terms at any time. Continued use of the Platform after changes
          constitutes acceptance of the updated Terms. We will notify users of material changes
          via email or in-app notification.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">11. Governing Law</h3>
        <p>
          These Terms are governed by the laws of the State of Tennessee, without regard to
          conflict of law principles.
        </p>
      </section>

      <section>
        <h3 className="text-white font-bold mb-1">12. Contact</h3>
        <p>
          For questions about these Terms, contact us at support@exodusadv.com.
        </p>
      </section>
    </div>
  );
};

export default TosContent;
